import React, { useState } from 'react';
import styled from 'styled-components';
import { cloudinaryUrl } from '../../lib/cloudinary';

interface ProductGalleryProps {
  imageIds: string[];
  alt: string;
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.md};
`;

const Hero = styled.img`
  width: 100%;
  aspect-ratio: 4 / 5;
  object-fit: cover;
`;

const Thumbs = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));
  gap: ${({ theme }) => theme.spacing.sm};
`;

const ThumbButton = styled.button<{ $active: boolean }>`
  padding: 0;
  cursor: pointer;
  border: 1px solid
    ${({ theme, $active }) => ($active ? theme.colors.primary : 'transparent')};
  opacity: ${({ $active }) => ($active ? 1 : 0.7)};
  transition: opacity ${({ theme }) => theme.transitions.short},
    border-color ${({ theme }) => theme.transitions.short};

  &:hover {
    opacity: 1;
  }

  img {
    width: 100%;
    aspect-ratio: 1 / 1;
    object-fit: cover;
    display: block;
  }
`;

const ProductGallery: React.FC<ProductGalleryProps> = ({ imageIds, alt }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const activeId = imageIds[activeIndex] ?? imageIds[0];

  return (
    <Wrapper>
      <Hero
        src={cloudinaryUrl(activeId, { width: 900, aspectRatio: '4:5' })}
        alt={alt}
      />
      {imageIds.length > 1 && (
        <Thumbs>
          {imageIds.map((id, i) => (
            <ThumbButton
              key={id}
              type="button"
              $active={i === activeIndex}
              onClick={() => setActiveIndex(i)}
              aria-label={`View image ${i + 1}`}
              aria-pressed={i === activeIndex}
            >
              <img
                src={cloudinaryUrl(id, { width: 200, aspectRatio: '1:1' })}
                alt=""
                loading="lazy"
              />
            </ThumbButton>
          ))}
        </Thumbs>
      )}
    </Wrapper>
  );
};

export default ProductGallery;
